import { ReactNode, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import loginService from "../../services/LoginService"

interface ProtectedRouteProps {
    children: ReactNode
    redirectTo?: string
}

export const ProtectedRoute = ({
    children,
    redirectTo = "/login"
}: ProtectedRouteProps) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const navigate = useNavigate()

    useEffect(() => {
        const checkAuth = () => {
            const token = loginService.getAuthToken()
            const authenticated = !!token
            setIsAuthenticated(authenticated)
            setIsLoading(false)

            if (!authenticated) {
                navigate(redirectTo, { replace: true })
            }
        }

        // Verificar imediatamente
        checkAuth()

        // Verificar novamente após um pequeno delay para garantir que o token foi salvo
        const timeoutId = setTimeout(checkAuth, 200)

        return () => clearTimeout(timeoutId)
    }, [navigate, redirectTo])

    if (isLoading) {
        return <div>Carregando...</div>
    }

    if (!isAuthenticated) {
        return null
    }

    return <>{children}</>
}
